import React from 'react'
import {
  useBranchDescription,
  BranchDescriptionProps,
} from './useBranchDescription'
import blockContentToHtml from '@sanity/block-content-to-html'
import TitleSection from 'components/TitleSection/TitleSection'

const BranchDescription: React.FC<BranchDescriptionProps> = (
  props: BranchDescriptionProps
) => {
  const { title, description } = useBranchDescription(props)

  return (
    <section className='py-5'>
      <div className='container'>
        <TitleSection title={title} />
        <div className='row'>
          <div
            className='col-12'
            dangerouslySetInnerHTML={{
              __html: Array.isArray(description)
                ? blockContentToHtml({
                    blocks: description,
                  })
                : `<p>${description}</p>`,
            }}
          ></div>
        </div>
      </div>
    </section>
  )
}

export default BranchDescription
